import React from "react";
import PropTypes from "prop-types";

const S3Link = props => {
  const { fileKey, text, isIframe, style } = props;
  const s3Url = `https://s3-us-west-1.amazonaws.com/${encodeURIComponent(fileKey)}`;
  return isIframe ? (
    <iframe src={s3Url} type="application/pdf" style={style} />
  ) : (
    <a target="_blank" rel="noopener noreferrer" href={s3Url}>
      {text}
    </a>
  );
};

S3Link.propTypes = {
  fileKey: PropTypes.string.isRequired,
  text: PropTypes.node,
  isIframe: PropTypes.bool
};

export default S3Link;
